import { OptionType } from '@/common/presentation/components/forms/fields/FormikAutocomplete';
import { ALLOWED_CALLER_ID_TYPES_SET } from '@/customers/application/types/CustomerTypes';
import { Contact, ContactInfo, defaultFormatContactName } from '@/common/presentation/hooks/useContactOptions';

export function buildConfirmedByOptions(contacts?: Contact[] | null): OptionType[] {
  if (!contacts || contacts.length === 0) return [];

  const allowedTypesSet = new Set<string>(Array.from(ALLOWED_CALLER_ID_TYPES_SET));
  const uniqueOptions = new Map<number, OptionType>();

  for (const contact of contacts) {
    const contactId = Number(contact.id ?? 0);
    if (isNaN(contactId) || contactId <= 0) continue;
    const infos = (contact.contactInformation ?? []) as ContactInfo[];
    const info = infos.find((ci) => ci?.type && allowedTypesSet.has(ci.type));
    const label =
      info != null
        ? defaultFormatContactName(contact, info)
        : `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || 'Unknown Contact';
    if (!uniqueOptions.has(contactId)) uniqueOptions.set(contactId, { value: contactId, label });
  }

  return Array.from(uniqueOptions.values());
}
